import React from 'react';

interface QuoteProps {
  text: string;
}

const Quote: React.FC<QuoteProps> = ({ text }) => {
  return (
    <p className="tw-w-full tw-py-10 tw-text-center tw-font-serif tw-text-2xl tw-font-normal tw-text-gray-700 md_tw-text-5xl">
      {text}
    </p>
  );
};

export default Quote;
